import { render } from "./Modal.vue?vue&type=template&id=16a05c62&scoped=true&lang=pug"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=16a05c62&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-16a05c62"

export default script